import * as React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"
// import BigNewsBox from "../components/BigNewsBox"
import OtherNews from "../components/OtherNews"
import InterestingArticle from "../components/InterestingArticle"
import HashTags from "../components/HashTags"
import FullArticle from "../components/FullArticle"
import EmptyWarning from "../components/EmptyWarning"
import styled from "styled-components"
import { blockContentToPlainText } from "react-portable-text"
import AmosovaLeftBanner from "../components/ads/AmosovaLeftBanner"
import AmosovaBigTopBanner from "../components/ads/AmosovaBigTopBanner"

const Article = ({ data }) => {
  const {
    title,
    subcategory,
    categories,
    publishedAt,
    tags,
    author,
    _rawBody,
    _rawMainImage,
    _rawExcerpt,
  } = data.allSanityPost.nodes[0]
  const tinyListNews = data.tinylist.nodes
  const ogImagePath = `${_rawMainImage.asset.url}?w=1200&h=627&fm=jpg`

  return (
    <Layout>
      <Seo
        title={title}
        description={blockContentToPlainText(_rawExcerpt)}
        image={ogImagePath}
      />
      {data.sanityAdBanner.positionsOtherPages.topBar && (
        <AmosovaBigTopBanner />
      )}
      <div className="max-w-screen-xl mx-auto">
        <div className="grid grid-cols-4 gap-5">
          <div className="col-span-4 md:col-span-4 lg:col-span-3 row-span-4">
            <FullArticle
              themeColor={categories.color}
              title={title}
              author={author}
              tags={tags}
              category={categories.title}
              subcategory={subcategory}
              publishDay={publishedAt}
              text={_rawBody}
              image={_rawMainImage}
            />
            <div className="grid grid-cols-2 gap-5">
              <div className="col-span-2 md:col-span-1">
                {/* <BigNewsBox mainPicture="https://source.unsplash.com/random" /> */}
              </div>
              <div className="col-span-2 md:col-span-1">
                {/* <BigNewsBox mainPicture="https://source.unsplash.com/daily" /> */}
              </div>
            </div>
          </div>
          <div className="col-span-4 md:col-span-4 lg:col-span-1">
            <div className="bg-fb-blue bg-opacity-5">
              {data.sanityAdBanner.positionsOtherPages.leftBar && (
                <AmosovaLeftBanner />
              )}
              <div className="relative" style={{ height: "60px" }}>
                <CategoryBar className="bg-fb-blue rounded-none md:rounded flex items-center pl-5 font-opensanscond text-white text-2xl inherit md:absolute">
                  Другие новости
                </CategoryBar>
              </div>
            </div>
            <div className="divide-y divide-gray-300 px-3 bg-fb-blue bg-opacity-5">
              {tinyListNews.length === 0 && <EmptyWarning />}
              {tinyListNews.map((tinyNews, index) => (
                <OtherNews
                  key={index}
                  themeColor={tinyNews.categories.color}
                  title={tinyNews.title}
                  category={tinyNews.subcategory}
                  categoryLink={tinyNews.categories.slug.current}
                  link={tinyNews.slug.current}
                />
              ))}
            </div>
            <InterestingArticle />
            <div>
              <HashTags />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}
export const query = graphql`
  query($pathSlug: String!, $categoryPath: String!) {
    allSanityPost(filter: { slug: { current: { eq: $pathSlug } } }) {
      nodes {
        title
        subcategory
        categories {
          title
          color
        }
        publishedAt(formatString: "DD-MM-YYYY")
        tags {
          title
          slug {
            current
          }
        }
        author {
          name
        }
        _rawBody(resolveReferences: { maxDepth: 10 })
        _rawMainImage(resolveReferences: { maxDepth: 10 })
        _rawExcerpt(resolveReferences: { maxDepth: 10 })
      }
    }
    tinylist: allSanityPost(
      sort: { fields: publishedAt, order: DESC }
      filter: { categories: { slug: { current: { eq: $categoryPath } } } }
      limit: 15
    ) {
      nodes {
        id
        slug {
          current
        }
        title
        categories {
          slug {
            current
          }
          color
        }
        subcategory
      }
    }
    sanityAdBanner(id: { eq: "-6025e2e7-5795-581f-97b5-7436c86dbe7b" }) {
      positionsOtherPages {
        topBar
        leftBar
      }
    }
  }
`
const CategoryBar = styled.div`
  bottom: 0px;
  right: 5px;
  width: 100%;
  height: 60px;
`
export default Article
